import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import OrderBranch from '../layouts/OrderBranch';

export const ProdukPerCabangPages = () => {
  const navigate = useNavigate();
  const { isAuthenticated, isInitialized, isLoading } = useSelector((state) => state.auth);

  useEffect(() => {
    if (!isInitialized || isLoading) return;
    if (!isAuthenticated) navigate('/', { replace: true });
  }, [isAuthenticated, isInitialized, isLoading, navigate]);

  return (
   <>
   <OrderBranch />
   </>
  )
}
